import { render } from "./CreateFirmwareModal.vue?vue&type=template&id=b13c5632"
import script from "./CreateFirmwareModal.vue?vue&type=script&lang=js"
export * from "./CreateFirmwareModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__